import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';

export function clientRequestEYContactsReducer(state = initialState.clientRequestEYContacts, action) {
	switch (action.type) {
		case types.GET_EY_CONTACTS: {
			if (HttpStatusCodes.Ok === action.responseObj.status && action.response) {
				return action.response;
			}
			return state;
		}

		default:
			return state;
	}
}
